import type { BadStatusError } from '@confluence/network';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';
import { processError } from '@confluence/graphql-error-processor/entry-points/GraphqlErrorProcessor.ts';

import { convertToApolloError } from './convertToApolloError.ts';

export type TransformErrorType = (
	error: Error | BadStatusError,
) => Promise<Error | BadStatusError> | Error | BadStatusError;

export const handleError = async ({
	error,
	transformError,
	onError,
}: {
	error: Error | BadStatusError;
	transformError?: TransformErrorType;
	onError?: (error: ApolloErrorInterop) => void;
}): Promise<ApolloErrorInterop> => {
	// The `transformError` callback can optionally return a new error to replace the original,
	// allowing for custom errors (e.g. based on the error's status code)
	const finalError = convertToApolloError((await transformError?.(error)) || error);

	// Process error for monitoring/analytics
	if (finalError.graphQLErrors?.length) {
		finalError.graphQLErrors.forEach((e) => {
			processError(e);
		});
	}

	onError?.(finalError);
	return finalError;
};
